import { useEffect, useRef } from 'react';

export default function usePrevious<T>(value: T) {
  const prev = useRef(value);

  useEffect(() => () => {
    prev.current = value;
  });

  return prev.current;
}
